import Vue from 'vue'
import VueYandexMetrika from 'vue-yandex-metrika-full-path'

import router from '../router'

Vue.use(VueYandexMetrika, {
  id: 54142246,
  router,
  env: 'production',
  scriptSrc: 'https://mc.yandex.ru/metrika/tag.js',
  webvisor: true,
  trackHash: true,
})
